/* eslint-disable camelcase */
export type PerformTokenResponse = {
    uuid: string;
    token_type: string;
    expires_in: number;
    access_token: string;
};

export type Perform = {
    token?: string;
    hashedUsername?: string;
};

export type PerformError = {
    message: string;
    code: string;
};

export function isPerformTokenError(input: PerformTokenResponse | PerformError): input is PerformError {
    return Boolean((input as PerformError).code && (input as PerformError).message);
}
